import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

interface Props {
    id: string;
    name?: string;
    isActive?: boolean;
}

const usePatchSlackChannels = () => {
    const { t } = useTranslation('integrations');
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);

    const patchUserSlackChannels = (prop: Props[]): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.patchUsersSlackChannels({
                body: prop,
                onSuccess: () => {
                    toastHandler.push('success', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsDescription'));
                    resolve();
                },
                onError: (error: AppError | string) => {
                    if (isErrorCode(error, ErrorCodes.SLACK_CHANNEL_PATTERN_ERROR)) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorSpecialCharacters'));
                    } else if (isErrorCode(error, ErrorCodes.SLACK_CHANNEL_NAME_EXISTS)) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorNameExists'));
                    } else if (isErrorCode(error, ErrorCodes.SLACK_CHANNEL_RESERVED)) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorReservedWord'));
                    } else {
                        const message = getUserMessage(error, t('slack.patchSlackChannelsError'));
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), message);
                    }
                    reject(new Error('Failed to patch Slack channels'));
                },
            });
            exec();
        });
    };

    return { patchUserSlackChannels };
};

export default usePatchSlackChannels;
